import React, { useState, useEffect } from "react";

export default function NewCricBuddyPortfolioSolution() {
  const data = [
    "Users can book sports venues in a few taps, receive instant confirmations, and securely pay deposits or fees.",
    "Venue owners to self-list venues, manage staff, control bookings and pricing, and monitor earnings in real time.",
    "Integrated WhatsApp updates, deposit management, rating/review systems, and OTP login for quick, secure access.",
    "Extensible support for various sports (box-cricket, football, badminton, etc.) and add-on modules like find-a-player or join-a-team.",
  ];

  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % data.length);
    }, 1500); // change highlight every 1.5s

    return () => clearInterval(interval);
  }, [data.length]);

  return (
    <section className="cb-solution-section">
      <div className="row">
        <div className="col-md-6 col-12 horizontal-padding">
          <h2 className="cb-cr-heading mb-4 clr-403E3E mb-4">
            SprigStack Solution
          </h2>
          <h3 className="cb-solution-h3">
            SprigStack engineered a robust, scalable web and app platform
            allowing:
          </h3>
          <ul className="cb-solution-ul">
            {data.map((val, idx) => (
              <li
                key={idx}
                className={`py-3 ps-2_5rem ${
                  activeIndex === idx ? "highlight-li" : ""
                }`}
              >
                {val}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
